// Database access layer (HTTP client). Keeps API calls in one place.
import axios from "axios";
import { STORAGE_TOKEN } from "../config";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const privateConfig = () => {
  const token = localStorage.getItem(STORAGE_TOKEN);
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getUsers = () => axios.get(`${API}/users`).then((r) => r.data);

export const setupPin = (payload) => axios.post(`${API}/pin/setup`, payload).then((r) => r.data);

export const login = (payload) => axios.post(`${API}/login`, payload).then((r) => r.data);

export const validateSession = (userId) =>
  axios.get(`${API}/session/${userId}`, privateConfig()).then((r) => r.data);

export const updateBirthDate = (userId, birthDate) =>
  axios.post(`${API}/profile/${userId}/birth-date`, { birthDate }, privateConfig()).then((r) => r.data);

export const getQuestions = () =>
  axios.get(`${API}/questions`, privateConfig()).then((r) => r.data);

export const getUnanswered = (userId) =>
  axios.get(`${API}/questions/unanswered/${userId}`, privateConfig()).then((r) => r.data);

export const getGameSession = (userId) =>
  axios.get(`${API}/game-session/${userId}`, privateConfig()).then((r) => r.data);

export const resetActiveSession = (userId) =>
  axios.post(`${API}/game-session/reset/${userId}`, {}, privateConfig()).then((r) => r.data);

export const activatePhotoChallenge = (sessionId, userId) =>
  axios.post(`${API}/game-session/${sessionId}/photo-challenge/${userId}`, {}, privateConfig()).then((r) => r.data);

export const uploadPrivatePhoto = (sessionId, userId, file) => {
  const form = new FormData();
  form.append("file", file);
  const config = privateConfig();
  return axios
    .post(`${API}/private-photos/${sessionId}/${userId}`, form, {
      ...config,
      headers: { ...(config.headers || {}), "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const getPrivatePhotos = (userId) =>
  axios.get(`${API}/private-photos/${userId}`, privateConfig()).then((r) => r.data);

export const getPrivatePhotoBlob = (photoId, userId) =>
  axios
    .get(`${API}/private-photos/${photoId}/content/${userId}`, {
      ...privateConfig(),
      responseType: "blob",
    })
    .then((r) => r.data);

export const submitAnswer = (payload) =>
  axios.post(`${API}/answers`, payload, privateConfig()).then((r) => r.data);

export const getUserAnswers = (userId) =>
  axios.get(`${API}/answers/${userId}`, privateConfig()).then((r) => r.data);

export const getMatches = (userId) =>
  axios.get(`${API}/matches/${userId}`, privateConfig()).then((r) => r.data);

export const markSeen = (matchId, userId) =>
  axios.post(`${API}/matches/${matchId}/seen/${userId}`, {}, privateConfig()).then((r) => r.data);

export const getDashboard = (userId) =>
  axios.get(`${API}/dashboard/${userId}`, privateConfig()).then((r) => r.data);

// Parallel commercial-session foundation. Tokens are never mixed with legacy PIN sessions.
export const createCommercialSession = (payload) =>
  axios.post(`${API}/v2/sessions`, payload).then((r) => r.data);

export const joinCommercialSession = (payload) =>
  axios.post(`${API}/v2/sessions/join`, payload).then((r) => r.data);

export const getCommercialSession = (sessionId, participantToken) =>
  axios
    .get(`${API}/v2/sessions/${sessionId}`, {
      headers: { Authorization: `Bearer ${participantToken}` },
    })
    .then((r) => r.data);
